import { Getters } from "vuex";
import { PointLogsGetters, PointLogsState } from "./types";

export const getters: Getters<PointLogsState, PointLogsGetters> = {};
